module.exports = function() {
  return new Worker(__webpack_public_path__ + "193021a0e5e6775469bf.worker.js");
};